import React from "react";
import { Link, useLocation } from "react-router-dom";

const NavLink = ({ to, children }) => {
  const location = useLocation();

  // Fonction pour vérifier si le lien doit être considéré comme actif
  const isActive = () => {
    // Pour la page d'accueil, on vérifie l'égalité exacte
    if (to === "/") {
      return location.pathname === to;
    }

    // Cas exacts : si l'URL correspond exactement
    if (location.pathname === to) {
      return true;
    }

    // Cas de l'URL parent direct
    // On compte les segments d'URL après 'to'
    const toPathSegments = to.split("/").filter(Boolean);
    const currentPathSegments = location.pathname.split("/").filter(Boolean);

    // Si le path actuel a exactement un segment de plus que le lien parent
    // et si tous les segments du parent sont inclus dans le path actuel
    // (par exemple, '/clients/particuliers' est un enfant direct de '/clients')
    if (
      currentPathSegments.length === toPathSegments.length + 1 &&
      toPathSegments.every(
        (segment, index) => currentPathSegments[index] === segment
      )
    ) {
      return true;
    }

    return false;
  };

  return (
    <Link
      to={to}
      className={`flex items-center text-gray-500 hover:text-white hover:bg-amber-500 rounded-lg p-2 cursor-pointer ${
        isActive() ? "bg-amber-500 text-white" : ""
      }`}
    >
      {children}
    </Link>
  );
};

export default NavLink;
